import { render, staticRenderFns } from "./IconNormalScreen.vue?vue&type=template&id=82be4792&scoped=true"
import script from "./IconNormalScreen.vue?vue&type=script&lang=js"
export * from "./IconNormalScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82be4792",
  null
  
)

export default component.exports